export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "admin";
    UserRole["MENTOR"] = "mentor";
    UserRole["MENTEE"] = "mentee";
    UserRole["MODERATOR"] = "moderator";
})(UserRole || (UserRole = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "active";
    UserStatus["INACTIVE"] = "inactive";
    UserStatus["PENDING_VERIFICATION"] = "pending_verification";
    UserStatus["SUSPENDED"] = "suspended";
    UserStatus["DEACTIVATED"] = "deactivated";
})(UserStatus || (UserStatus = {}));
export var ExperienceLevel;
(function (ExperienceLevel) {
    ExperienceLevel["ENTRY"] = "entry";
    ExperienceLevel["JUNIOR"] = "junior";
    ExperienceLevel["MID"] = "mid";
    ExperienceLevel["SENIOR"] = "senior";
    ExperienceLevel["LEAD"] = "lead";
    ExperienceLevel["EXECUTIVE"] = "executive";
})(ExperienceLevel || (ExperienceLevel = {}));
export var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["AVAILABLE"] = "available";
    AvailabilityStatus["BUSY"] = "busy";
    AvailabilityStatus["NOT_AVAILABLE"] = "not_available";
})(AvailabilityStatus || (AvailabilityStatus = {}));
//# sourceMappingURL=user-roles.enum.js.map